import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { FormularioComponent } from './formulario/formulario.component';
import { MatriculaComponent } from './matricula/matricula.component';
import { IncorporacionFinancieraComponent } from './incorporacion-financiera/incorporacion-financiera.component';
import { CambiarGrupoComponent } from './cambiar-grupo/cambiar-grupo.component';
import { AuthGuard } from '../../auth-guard.service';

const routes: Routes = [
  {
    path: 'control-escolar/grupo',
    children: [
      { path: 'lista', component: ListaComponent },
      { path: 'nuevo', component: FormularioComponent },
      { path: 'editar/:id', component: FormularioComponent },
      { path: 'matricula', component: MatriculaComponent },
      { path: 'incorporacion', component: IncorporacionFinancieraComponent },
      { path: 'cambiar', component: CambiarGrupoComponent }
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class GrupoRoutingModule { }

